import { createFileRoute } from '@tanstack/react-router'
import { useBreadcrumbFromRoute } from '@/hooks/use-breadcrumb-from-route'
import { SectionNavGrid } from '@/components/shared/section-nav-grid'
import { ContactRound, Building2, Mail } from 'lucide-react'

export const Route = createFileRoute('/_app/crm')({
  component: CRMIndexPage,
})

function CRMIndexPage() {
  useBreadcrumbFromRoute()

  const navItems = [
    {
      title: 'Contacts',
      url: '/contacts',
      icon: ContactRound,
      description: 'Manage your contacts and relationships',
    },
    {
      title: 'Companies',
      url: '/companies',
      icon: Building2,
      description: 'Manage companies and organizations',
    },
    {
      title: 'Marketing',
      url: '/marketing',
      icon: Mail,
      description: 'Create and manage marketing campaigns',
    },
  ]

  return (
    <SectionNavGrid
      title="CRM"
      description="Manage your customer relationships and marketing efforts."
      items={navItems}
    />
  )
}
